module.exports = __webpack_public_path__ + "img/seven_zhCn.09053ca8.png";